import { Link } from "react-router-dom";
import { UserCheck, Trophy } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export default function Index() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="bg-primary text-white py-6">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center space-x-3">
            <img
              src="https://cdn.builder.io/api/v1/image/assets%2F525330fe20684a269584d84d399c39f6%2Fe804dffb024540e5b053023d69334fd2?format=webp&width=800"
              alt="Boulder Academia Logo"
              className="w-16 h-16 object-contain"
            />
            <div className="text-center">
              <h1 className="text-3xl font-bold">Festival de Escalada</h1>
              <p className="text-blue-100 text-xl">Boulder Academia</p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12 flex-1">
        <div className="text-center mb-12 text-gray-600 max-w-2xl mx-auto">
          <p className="text-xl font-semibold text-gray-800 mb-3">
            Bem-vindo ao Festival de Escalada!
          </p>
          <p>
            Escolha abaixo qual é o seu papel na competição para acessar a área correspondente.
          </p>
        </div>

        {/* Navigation Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Sou um Atleta */}
          <Card className="hover:shadow-lg transition-shadow cursor-pointer group">
            <CardHeader className="text-center">
              <div className="w-20 h-20 mx-auto bg-primary/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <Trophy className="w-10 h-10 text-primary" />
              </div>
              <CardTitle className="text-2xl">Sou um Atleta</CardTitle>
              <CardDescription className="text-base mt-3">
                Consulte seus resultados e acompanhe seu ranking em tempo real
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/consulta">
                <Button className="w-full h-12 text-lg">
                  Meus Resultados
                </Button>
              </Link>
            </CardContent>
          </Card>

          {/* Sou um Juiz */}
          <Card className="hover:shadow-lg transition-shadow cursor-pointer group">
            <CardHeader className="text-center">
              <div className="w-20 h-20 mx-auto bg-primary/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <UserCheck className="w-10 h-10 text-primary" />
              </div>
              <CardTitle className="text-2xl">Sou um Juiz</CardTitle>
              <CardDescription className="text-base mt-3">
                Registre tentativas e pontuações durante a competição
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/juiz">
                <Button className="w-full h-12 text-lg">Registrar Tentativas</Button>
              </Link>
            </CardContent>
          </Card>
        </div>

      </main>

      {/* Footer */}
      <footer className="bg-gray-100 py-8">
        <div className="container mx-auto px-4 text-center text-gray-600">
          <p>&copy; 2026 Festival de Escalada - Boulder Academia</p>
        </div>
      </footer>
    </div>
  );
}
